module.exports = __webpack_public_path__ + "img/tech 8.b93b6e84.png";